import React, { useState, useEffect } from 'react';

import { Add } from '@mui/icons-material';
import { Tooltip, Fab } from "@mui/material";

import Grid from '@mui/material/Grid2';

import { FeatureSource, ModelBase } from "@models";
import { 
  GameClass,
  Subclass, UpgradableNumber, 
} from "@dndModels";

import SelectObjectBox from "@components/input/selects/SelectObjectBoxSimple";

import FeatureSourceInput from "@dndComponents/FeatureSourceInput";

import API from "@utilities/smart_api";
import CommonUtilities from "@utilities/common_utilities";
import EditableLabel from "@components/input/strings/EditableLabel";
import UpgradableNumberBox from "@dndComponents/UpgradableNumberBox";
import DisplayObjects from "@dndComponents/display/DisplayObjects";

const api = API.getInstance();
const common_util = CommonUtilities.getInstance();

interface Props {
  obj?: ModelBase;
}

export default function SubclassEdit({ obj: param_obj }: Props) {
  const [reloading, setReloading] = useState(false);
  const [obj, setObj] = useState<Subclass>(param_obj instanceof Subclass ? param_obj : api.applyWorkingOn(new Subclass()));
  const [change_time, setChangeTime] = useState(0);
  
  const disabled = api.user === null || !api.online || (!api.user.admin && obj._id !== "" && obj.owner_id !== api.user._id);
    
  useEffect(() => {
    if (reloading) {
      setReloading(false);
    }
  }, [reloading, setReloading]);

  console.log(obj);
  return (
    <FeatureSourceInput 
      obj={obj}
      data_type="subclass"
      disabled={disabled}
      change_time={change_time}
      onChange={(changed: FeatureSource) => {
        if (changed instanceof Subclass) {
          const new_obj = obj;
          new_obj.copy(changed);
          setObj(new_obj);
        }
      }}
      onSubmitted={changed => {
        if (changed instanceof Subclass) {
          const game_class = api.getDataTypeFromHash<GameClass>("game_class").find(o => o._id === changed.game_class_id);
          if (game_class instanceof GameClass) {
            changed.game_class = game_class;
          }
        }
      }}
      header={ disabled ? 
        <>
          <span className="header">Class:</span> <DisplayObjects type="game_class" ids={[obj.game_class_id]} />
        </> 
      :
        <SelectObjectBox 
          name="Class"
          data_type="game_class"
          value={ obj.game_class_id ? obj.game_class_id : "" } 
          disabled={disabled}
          onChange={(id: string) => {
            const new_obj = obj;
            new_obj.game_class_id = id;
            setObj(new_obj);
            setChangeTime(common_util.get_time_number());
          }}
        />
      }
      extra_menu_options={{"Attributes": 
        <Grid container spacing={0} direction="row">
          <Grid
            size={{
              xs: 12
            }}>
            <span className="header">
              Formulae
            </span>
            { !disabled &&
              <Tooltip title={`Create New Formula`}>
                <Fab size="small" color="primary" style={{marginLeft: "8px"}}
                  onClick={ () => {
                    const new_obj = obj;
                    new_obj.formulae["New Formula"] = new UpgradableNumber();
                    setObj(new_obj);
                    setChangeTime(common_util.get_time_number());
                    setReloading(true);
                  }}>
                  <Add/>
                </Fab>
              </Tooltip>
            }
          </Grid>
          { !reloading && Object.keys(obj.formulae).sort((a, b) => {
            return a.localeCompare(b);
          }).map((formula_key, key) => {
            return (
              <Grid
                key={key}
                container
                spacing={0}
                direction="row"
                size={{
                  xs: 12
                }}>
                <Grid
                  size={{
                    xs: 2
                  }}>
                  <EditableLabel 
                    name="Formula Key"
                    value={formula_key}
                    onChange={(changed: string) => {
                      const new_obj = obj;
                      const old_value = new_obj.formulae[formula_key].clone();
                      delete new_obj.formulae[formula_key];
                      new_obj.formulae[changed] = old_value;
                      setObj(new_obj);
                      setChangeTime(common_util.get_time_number());
                      setReloading(true);
                    }}
                  />
                </Grid>
                <Grid
                  size={{
                    xs: 10
                  }}>
                  <UpgradableNumberBox 
                    value={ obj.formulae[formula_key] as UpgradableNumber } 
                    name={ formula_key }
                    disabled={disabled}
                    onChange={(changed: UpgradableNumber) => {
                      const new_obj = obj;
                      new_obj.formulae[formula_key] = changed;
                      setObj(new_obj);
                      setChangeTime(common_util.get_time_number());
                    }}
                  />
                </Grid>
              </Grid>
            );
          })}
        </Grid>
      }}
    />
  ); 
}